import { SUBJECT_TYPE } from 'src/constants';

export class SubjectsManager {
    static getSubjectTypesBasic(): SUBJECT_TYPE[] {
        const subjectTypes = [SUBJECT_TYPE.NORMAL, SUBJECT_TYPE.FOREIGN];
        return subjectTypes;
    }
}
